import { render, staticRenderFns } from "./serverEdit.vue?vue&type=template&id=5ae9858e&scoped=true&"
import script from "./serverEdit.vue?vue&type=script&lang=js&"
export * from "./serverEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ae9858e",
  null
  
)

export default component.exports